export default __webpack_public_path__ + "static/media/category-10.70615958.svg";